import {
  AppealResponsesInitialState,
  AppealRecommendationsResponse,
  AppealResponsesResponse,
  ServiceCategoriesResponse,
} from './types';
import { ActionTypesAppealResponses } from './constants';

const appealResponsesInitialState: AppealResponsesInitialState = {
  appealResponsesData: [],
  showAppealResponsesGrid: false,
  isAppealResponsesGridLoading: false,
  reconsiderationDropdowns: {
    appealRecommendations: [],
    appealResponses: [],
    serviceCategories: [],
  } as {
    appealRecommendations: AppealRecommendationsResponse[];
    appealResponses: AppealResponsesResponse[];
    serviceCategories: ServiceCategoriesResponse[];
  },
  isReconsiderationDropdownsLoading: false,
};

const appealResponsesReducer = (state = appealResponsesInitialState, action) => {
  switch (action.type) {
    case ActionTypesAppealResponses.SET_APPEAL_RESPONSES_DATA:
      return {
        ...state,
        appealResponsesData: action.appealResponsesData,
      };
    case ActionTypesAppealResponses.SHOW_APPEAL_RESPONSES_GRID:
      return {
        ...state,
        showAppealResponsesGrid: action.showAppealResponsesGrid,
      };
    case ActionTypesAppealResponses.SET_LOADING_INDICATOR:
      return {
        ...state,
        isAppealResponsesGridLoading: action.isAppealResponsesGridLoading,
      };
    case ActionTypesAppealResponses.RESET_APPEAL_RESPONSES:
      return {
        ...state,
        appealResponsesData: [],
        showAppealResponsesGrid: false,
      };
    case ActionTypesAppealResponses.SET_RECONSIDERATION_DROPDOWNS:
      return {
        ...state,
        reconsiderationDropdowns: action.reconsiderationDropdowns,
      };
    case ActionTypesAppealResponses.TOGGLE_RECONSIDERATION_DROPDOWNS_LOADING:
      return {
        ...state,
        isReconsiderationDropdownsLoading: action.isReconsiderationDropdownsLoading,
      };
    default:
      return state;
  }
};

export default appealResponsesReducer;
